import React from 'react'
import PropTypes from 'prop-types'
import { Link } from '@paper-monster/web/src/components/common'
import { useSiteConfig } from '@paper-monster/web/src/components/Providers/SiteConfigProvider'

import routes from '@/routes'

// The trial SKU and the lead source come from the site config, so the
// attribution names the SKU the link opens.
const TryFreeCta = ({
  buttonMessageId = 'cta.tryNeatFree',
  sku,
  ...props
}) => {
  const { sources, trialSku } = useSiteConfig()
  const ctaSku = sku ?? trialSku

  return (
    <Link
      data-buyinfo={JSON.stringify({ sku: ctaSku, source: sources.trialCta })}
      messageId={buttonMessageId}
      size="xlarge"
      to={`${routes.signUp}?sku=${ctaSku}`}
      variant="success"
      {...props}
    />
  )
}

TryFreeCta.propTypes = {
  sku: PropTypes.string,
  buttonMessageId: PropTypes.string,
}

export default TryFreeCta
